document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  if (accordionHeaders.length === 0) {
    console.warn('No se encontraron elementos con clase .accordion-header');
    return;
  }
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const body = this.nextElementSibling;
      // Si ya está abierto, colapsarlo; de lo contrario, cerramos todos y abrimos este.
      if (body.style.display === 'block') {
        body.style.display = 'none';
      } else {
        // Cierra todos los cuerpos (para que sólo uno se abra a la vez)
        accordionHeaders.forEach(h => {
          h.nextElementSibling.style.display = 'none';
        });
        body.style.display = 'block';
      }
    });
  });
});
